module.exports = __webpack_public_path__ + "img/card-event-01-button-sm.2d45a0a3.svg";